import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generic Filter Pipe for Angular
 * 
 * Usage examples:
 * 
 * 1. Filter by property value:
 *    *ngFor="let item of items | filter: 'Y' : 'IS_ACTIVE'"
 * 
 * 2. Filter by object criteria:
 *    *ngFor="let item of items | filter: {STATUS: 'active', TYPE: 'user'}"
 * 
 * 3. Filter by function:
 *    *ngFor="let item of items | filter: myFilterFunction"
 * 
 * 4. Text search across all properties:
 *    *ngFor="let item of items | filter: 'search term'"
 */
@Pipe({
    name: 'filter',
    pure: false // Allows filtering to work with mutable arrays
    ,
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], filter?: any, filterProperty?: string): any[] {
    if (!items || !filter) {
      return items;
    }

    // If filter is a function, use it directly
    if (typeof filter === 'function') {
      return items.filter(filter);
    }

    // If filter is an object (e.g., {EDIT_TYPE: 'radio'})
    if (typeof filter === 'object' && !Array.isArray(filter)) {
      return items.filter(item => {
        return Object.keys(filter).every(key => {
          return item[key] === filter[key];
        });
      });
    }

    // If filter is a simple value and filterProperty is provided
    if (filterProperty) {
      return items.filter(item => {
        return item[filterProperty] === filter;
      });
    }

    // If filter is a simple string, search in all string properties
    if (typeof filter === 'string') {
      const searchTerm = filter.toLowerCase();
      return items.filter(item => {
        return Object.keys(item).some(key => {
          const value = item[key];
          return value && typeof value === 'string' && 
                 value.toLowerCase().includes(searchTerm);
        });
      });
    }

    // Default: return original array if no valid filter found
    return items;
  }
} 